import { Component } from "react";
import { formatUrlSeo } from "../../util/seo-url";
import React = require("react");
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import { TinTuc } from "../../models";
import * as _ from "lodash";
var Chance = require('chance');
const chance = new Chance();

import Image from "../../components/share/Image";
import { NEWS } from "../../const/seo-url";
import CarouselSlide from "../share/CarouselSlide";
import { extractDate } from "../../util/date_new/extractDate";
import SpinnersImageText from "../share/Spinners/SpinnersImageText";

export default class extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinQuanTam: [],
      loading: false,
      firstDuAn: null,
      slides: []
    }
  }

  static async getInitialProps() {

    return
  }


  componentDidMount() {
    TinTucService.getList(
      DANH_MUC.LICH_SU_KIEN,
      1,
      3
    ).then(value => {
      if (value.danhSachTinTuc) {
        if (value.danhSachTinTuc.length > 0) {
          let numberTinTusPerSlide = 3;
          let numberOfSlide = getNumberOfSlide(value.danhSachTinTuc.length);
          let listOfTinTucsPerSlide = _.chunk(value.danhSachTinTuc, numberTinTusPerSlide);
          for (let i = 0; i < numberOfSlide; i++) {
            let guid = chance.guid();
            this.state.slides.push(<Slide key={guid} tinTucs={listOfTinTucsPerSlide[i]} />);
            value.danhSachTinTuc.forEach(element => {
              element['url_seo_du_an'] = formatUrlSeo(element['url'], element['id']);
            });
          }
        }
        this.setState({
          loading: true
        });

      }
    });
  }

  render() {
    return (
      <div className="block  back-lichsukien" >
        <div className="container nopadding">
          <div className="col text-center block-title text-white">
            EVENTS
          </div>
          {
            this.state.loading ?
              // this.state.slides 
              (
                // <CarouselSlide
                //   id="sukienCarousel"
                //   arrowNextClass="carousel-control-next-event"
                //   arrowPrevClass="carousel-control-prev-event"
                // >
                <div id="sukienCarousel123" className="carousel slide" data-ride="carousel">
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      {this.state.slides}

                    </div>
                  </div>
                </div>
                // </CarouselSlide>
              )
              : <SpinnersImageText type={'placeholde'} loading={true} />
          }
        </div>
      </div >
    );

  }
}
const Slide = ({ tinTucs }: { tinTucs: TinTuc[] }) => {
  return (
    <div className="row">
      {tinTucs.map(tinTuc => {
        const { date, month } = extractDate(tinTuc.moTa);
        return (
          <div key={tinTuc.id} className="col-md-4">
            <div className="row col event">
              <div className="col-md event-right">
                <div>
                  <Image src={tinTuc.hinhThumbnail} alt="" className="img-fluid" classPlaceHolder="lazy-image-su-kien" />
                </div>
                {/* <div className="text-center p-2">
                  <b className="text-red" style={{ fontSize: "20px" }}>{tinTuc.tieuDe}</b>
                  <div className="text-blue-3" style={{ fontSize: "15px" }} dangerouslySetInnerHTML={{ __html: tinTuc.noiDung }} />
                </div> */}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

function getNumberOfSlide(numberOfTinTuc: number): number {
  if (numberOfTinTuc <= 3) {
    return 1;
  }
  if (numberOfTinTuc <= 9) {
    return 2;
  }
  if (numberOfTinTuc <= 12) {
    return 3;
  }
  return 3;
}
